(function () {
	'use strict';

	// Initial-load polish for product pages. Three things, fire once on first
	// render of the page, then this script does nothing more.
	//
	//  1. Uncheck all option radios so no value appears preselected. The
	//     hidden variant-id input still carries Shopify's default-resolved
	//     variant (the form still works for screen readers and any non-JS
	//     submission), but visually no value looks 'committed'.
	//  2. Disable buy buttons so the customer must engage the option pickers
	//     before the cart submission can fire. After the customer picks any
	//     option, the theme's variant-change handler in custom-async.js
	//     replaces .f8pr-buy-button with fresh server-rendered markup that
	//     correctly reflects in-stock vs sold-out for that variant.
	//  3. Hide .f8pr-codes (SKU + Barcode display) so the default variant's
	//     identifiers don't show. Same replacement-on-pick mechanism as the
	//     buy button — once any option is picked, the theme renders the new
	//     .f8pr-codes naturally.
	//
	// Anything that happens AFTER the first option click — option-dependency
	// greying, auto-resolved variants, toggle-deselect, etc. — is left to the
	// theme's existing behaviour. This file only suppresses the pre-interaction
	// state.

	if (window.__variantInitPolishApplied) return;
	window.__variantInitPolishApplied = true;

	function uncheckOptionRadios() {
		var radios = document.querySelectorAll('input[type="radio"][name^="options["]');
		for (var i = 0; i < radios.length; i++) {
			radios[i].checked = false;
		}
	}

	function disableBuyButtons() {
		var selectors = [
			'.f8pr-buy-button button',
			'.f8pr-buy-button input[type="submit"]',
			'form button[name="add"]',
			'form input[type="submit"][name="add"]'
		];
		var seen = new WeakSet();
		for (var s = 0; s < selectors.length; s++) {
			var els = document.querySelectorAll(selectors[s]);
			for (var i = 0; i < els.length; i++) {
				var el = els[i];
				if (seen.has(el)) continue;
				seen.add(el);
				el.disabled = true;
			}
		}
	}

	function hideVariantCodes() {
		var els = document.querySelectorAll('.f8pr-codes');
		for (var i = 0; i < els.length; i++) {
			els[i].style.display = 'none';
		}
	}

	function applyInitialPolish() {
		try {
			// Skip on variant URLs (?variant=<id>) — the customer landed on a specific
			// variant's detail page and should see that variant selected, with SKU/
			// Barcode and Buy buttons active. Polish only applies to the bare product
			// URL (browse mode for the comparison table or standard page).
			var search = window.location.search || '';
			if (search.indexOf('variant=') !== -1) {
				return;
			}
			// Skip on single-variant / no-options products: there's nothing for the
			// customer to pick, so disabling the buy button or hiding SKU/Barcode
			// would just lock them out of buying. The polish only makes sense when
			// there are option radios to engage with.
			var radios = document.querySelectorAll('input[type="radio"][name^="options["]');
			if (radios.length === 0) {
				return;
			}
			uncheckOptionRadios();
			disableBuyButtons();
			hideVariantCodes();
		} catch (e) {
			/* fail silently — initial polish is non-critical UX */
		}
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', applyInitialPolish);
	} else {
		applyInitialPolish();
	}
})();
